import {atom} from "jotai/index";
import {Link} from "react-router-dom";
import {decimalFormat} from "../../../common/StringUtils";
import React from "react";
import Icon from "../../../components/icon";

/**
 * 타겟팅 단가 광고주 리스트 Atom
 * @type {Atom<unknown>}
 */
export const eventUnitPriceDataAtom = atom(null)

/**
 * 타겟팅 단가 광고주별 상세 리스트 Atom
 * @type {Atom<unknown>}
 */
export const eventUnitPriceDetailDataAtom = atom(null)

/**
 * 타겟팅 단가 광고주 리스트 컬럼세팅
 * @type {[{defaultFlex: number, name: string, cellProps: {style: {textDecoration: string}}, header: string, render: (function(*): *)},{defaultFlex: number, resizable: boolean, name: string, header: string},{defaultFlex: number, resizable: boolean, name: string, header: string},{defaultFlex: number, resizable: boolean, name: string, header: string}]}
 */
export const adverEventPriceColumns = [
  {
    name: 'adverName',
    header: '광고주명',
    defaultFlex: 1,
    cellProps: {
      style: {
        textDecoration: 'underline'
      }
    },
    render: (props) => {
      return (
        <Link to={'/board/settingsDetail'} state={{id: props.data.userId}}>{props.value}</Link>
      )
    }
  },
  {
    name: 'username',
    header: '광고주 아이디',
    defaultFlex: 1,
    resizable: false,
  },
  {
    name: 'managerName',
    header: '담당자',
    defaultFlex: 1,
    resizable: false,
  },
  {
    name: 'count',
    header: '등록된 타겟팅 단가 그룹',
    defaultFlex: 1,
    resizable: false
  }
]

/**
 * 타겟팅 단가 광고주별 상세 리스트 컬럼 세팅
 * @type {[{defaultFlex: number, name: string, header: string},{defaultFlex: number, resizable: boolean, name: string, header: string, render: (function({value: *}): *)},{defaultFlex: number, resizable: boolean, name: string, header: string, render: (function({value: *}): *)},{defaultFlex: number, resizable: boolean, name: string, header: string, render: (function({value: *}): *)},{defaultFlex: number, resizable: boolean, name: string, header: string, render: (function({value: *}): *)},null,null]}
 */
export const eventUnitPriceDetailColumns = [ //타겟팅 단가 상세 컬럼
  {
    name: 'groupName',
    header: '타겟팅 단가 그룹명',
    defaultFlex: 1,
    render: (props) => {
      return (
        <div style={{display: "flex", alignItems: 'center', justifyContent : 'center'}}>
          <p>{props.value}</p>
          <Icon saveType={'edit'} cellProps={props.cellProps.data} label={'won'}/>
        </div>
      )
    }
  },
  {
    name: 'cartRecommendation',
    header: '카트 추천',
    defaultFlex: 1,
    resizable: false,
    render: ({ value })=> <p className={'won'}>{decimalFormat(value)}</p>
  },
  {
    name: 'productRecommendation',
    header: '상품 추천',
    defaultFlex: 1,
    resizable: false,
    render: ({ value })=> <p className={'won'}>{decimalFormat(value)}</p>
  },
  {
    name: 'userMatching',
    header: '유저매치',
    defaultFlex: 1,
    resizable: false,
    render: ({ value })=> <p className={'won'}>{decimalFormat(value)}</p>
  },
  {
    name: 'userOptimization',
    header: '유저 최적화',
    defaultFlex: 1,
    resizable: false,
    render: ({ value })=> <p className={'won'}>{decimalFormat(value)}</p>
  }
]
